import * as React from 'react'
import { findLast } from 'lodash'
import { inject, observer } from 'mobx-react'
import { ComponentExt } from 'util/reactExt'
import styles from './index.scss'
import { checkStatus, checkType } from 'constants/index'
import Bubble from 'components/Bubble'
import videoIcon from 'assets/check/video.svg'
import videoLockIcon from 'assets/check/video-lock.svg'
import examIcon from 'assets/check/exam.svg'
import examLockIcon from 'assets/check/exam-lock.svg'
import exampleIcon from 'assets/check/example.svg'
import exampleLockIcon from 'assets/check/example-lock.svg'
import textIcon from 'assets/check/text.svg'
import textLockIcon from 'assets/check/text-lock.svg'
import lastIcon from 'assets/check/last.svg'
import lastLockIcon from 'assets/check/last-lock.svg'
import lockIcon from 'assets/check/lock.svg'
import doneIcon from 'assets/check/done.png'

const dataFormatter = data => (data && data.meta ? data.data : data)

const checkStatusIcon = {
  [checkStatus.todo]: {},
  [checkStatus.doing]: {},
  [checkStatus.done]: {
    backgroundImage: `url(${doneIcon})`,
    width: 80,
    height: 36,
    top: -14,
    left: '50%',
    transform: 'translateX(-50%)',
  },
  [checkStatus.discard]: {},
  ['locked']: {
    backgroundImage: `url(${lockIcon})`,
    width: 48,
    height: 58,
    right: 40,
    top: -10,
  },
  use(opt: { status: string; isLocked: boolean }) {
    /* tslint:disable */
    if (opt.isLocked) {
      return this['locked']
    } else {
      return this[opt.status]
    }
  },
}

const checkTypeIcon = {
  [checkType.integration]: {
    ['locked']: videoLockIcon,
    '*': videoIcon,
  },
  [checkType.example]: {
    ['locked']: exampleLockIcon,
    '*': exampleIcon,
  },
  [checkType.exam]: {
    ['locked']: examLockIcon,
    '*': examIcon,
  },
  [checkType.text]: {
    ['locked']: textLockIcon,
    '*': textIcon,
  },
  use(opt: { type: string; isLocked: boolean }) {
    /* tslint:disable */
    const { type, isLocked } = opt

    if (isLocked) {
      return this[type]['locked']
    } else {
      return this[type]['*']
    }
  },
}

interface ICheckProps {
  data: any
  total: number
  lastIndexOfPass?: number
  lastCheckOfDoing: any
  openCheckPanelModal: () => void
  checkHoverId: number
  acitveGroupId?: number | string
}

class Check extends React.Component<ICheckProps, any> {
  state = {
    checkHoverId: -1,
  }

  toggleCheckHoverId = id => {
    this.setState({ checkHoverId: id })
  }

  render() {
    const {
      data: {
        id,
        status,
        check: { type, name },
        is_locked,
        grade,
        overtime,
        done_task_count,
        task_count,
      },
      total,
      // checkHoverId,
      lastCheckOfDoing,
      openCheckPanelModal,
      acitveGroupId,
    } = this.props

    const { checkHoverId } = this.state
    const isCurrentCheck = checkHoverId === id
    return (
      <div
        className={styles.checkWrapper}
        onClick={openCheckPanelModal}
        onMouseEnter={this.toggleCheckHoverId.bind(this, id)}
        onMouseLeave={this.toggleCheckHoverId.bind(this, -1)}
      >
        <div className={styles.check}>
          <div
            style={{
              backgroundImage: `url(${
                grade === total && !acitveGroupId
                  ? is_locked
                    ? lastLockIcon
                    : lastIcon
                  : checkTypeIcon.use({ type, isLocked: is_locked })
              })`,
            }}
            className={styles.checkTypeIcon}
          />
          <div className={styles.checkPlatform} />
          <div className={styles.checkProgress}>
            {done_task_count}/{task_count}
          </div>

          <div className={styles.checkName}>Lv{grade}</div>
          <div
            className={styles.checkStatusIcon}
            style={checkStatusIcon.use({ status, isLocked: is_locked })}
          />
          {lastCheckOfDoing && lastCheckOfDoing.id === id && (
            <div className={styles.checkBlink} />
          )}

          {
            <Bubble
              style={{
                width: 176,
                height: 87,
                position: 'absolute',
                top: -130,
                left: -6,
                color: '#85574E',
                fontSize: 12,
                textAlign: 'center',
                lineHeight: '80px',
                zIndex: 4,
                visibility: isCurrentCheck ? 'visible' : 'hidden',
                opacity: isCurrentCheck ? 1 : 0,
                transition: 'all 1s cubic-bezier(0.19, 1, 0.22, 1)',
              }}
            >
              {overtime === '是' ? (
                <div
                  style={{
                    position: 'absolute',
                    width: '100%',
                    lineHeight: '20px',
                    left: '50%',
                    top: '40%',
                    transform: 'translate(-50%, -50%)',
                  }}
                >
                  该关卡（{name}）<br />
                  已超时，请及时通关！
                </div>
              ) : (
                name
              )}
            </Bubble>
          }
        </div>
      </div>
    )
  }
}

interface ICheckGroupBoardProps {
  globalStore?: any
  levelStore?: any
  openCheckPanelModal?: (check: any) => void
  useShadow?: boolean
  onRef?: (ref: any) => any
  acitveGroupId?: number | string
}

interface ICheckGroupBoardState {
  currentCheckGroupIndex: number // 当前关卡分组 index
  checkHoverId: number
  leftBtnMode: string
  rightBtnMode: string
}

@inject('globalStore', 'levelStore')
@observer
export default class CheckGroupBoard extends ComponentExt<
  ICheckGroupBoardProps,
  ICheckGroupBoardState
> {
  state = {
    currentCheckGroupIndex: 0,
    checkHoverId: -1,
    leftBtnMode: '<:up',
    rightBtnMode: '>:up',
  }

  componentDidMount() {
    if (this.props.onRef) {
      this.props.onRef(this)
    }
  }

  get checkGroups(): any {
    let {
      levelStore: {
        userCheckRecord: { data },
      },
    } = this.props

    const checkGroups = []

    dataFormatter(data).forEach((check, index) => {
      // 关卡处于分组的范围，分组以 10 个关卡为一组
      const currentCheckGroupNo: number = parseInt((index / 10).toString())
      if (!checkGroups[currentCheckGroupNo]) {
        checkGroups[currentCheckGroupNo] = []
      }
      checkGroups[currentCheckGroupNo].push(check)
    })

    return checkGroups
  }

  get lastCheckOfDoing(): any {
    const {
      levelStore: {
        userCheckRecord: { data },
      },
    } = this.props
    const lastCheckOfDoing = findLast(
      data,
      check => check.status === checkStatus.doing,
    )
    return lastCheckOfDoing
  }

  openCheckPanelModal = (check: any): void => {
    this.props.openCheckPanelModal(check)
  }

  gotoCheck = (mode: string): void => {
    let { currentCheckGroupIndex } = this.state
    if (
      mode === 'next' &&
      currentCheckGroupIndex === this.checkGroups.length - 1
    ) {
      return
    }

    if (mode === 'prev' && currentCheckGroupIndex === 0) {
      return
    }

    if (mode === 'next') {
      this.setCurrentCheckGroup(currentCheckGroupIndex + 1)
    } else {
      this.setCurrentCheckGroup(currentCheckGroupIndex - 1)
    }
  }

  setCurrentCheckGroup = (index: number): void => {
    this.setState({
      currentCheckGroupIndex: index,
    })
  }

  switchBtnBg = (mode: string): void => {
    const [direction] = mode.split(':')

    if (direction === '<') {
      this.setState({
        leftBtnMode: mode,
      })
    } else {
      this.setState({
        rightBtnMode: mode,
      })
    }
  }

  renderProgress = () => {
    const { currentCheckGroupIndex, leftBtnMode, rightBtnMode } = this.state
    return (
      <section className={styles.checkControls}>
        <a
          className={`${styles.leftBtn} ${
            leftBtnMode === '<:up' ? styles.leftUpBtn : styles.leftPressBtn
          }`}
          onClick={this.gotoCheck.bind(this, 'prev')}
          onMouseDown={this.switchBtnBg.bind(this, '<:press')}
          onMouseUp={this.switchBtnBg.bind(this, '<:up')}
        />

        <ul className={styles.checkControlsProgress}>
          {this.checkGroups.map((checkGroup, index) => (
            <li
              key={index}
              onClick={this.setCurrentCheckGroup.bind(this, index)}
              className={`${styles.checkControlsProgressItem} ${
                currentCheckGroupIndex === index ? `${styles.active}` : ''
              }`}
            />
          ))}
        </ul>
        <a
          className={`${styles.rightBtn} ${
            rightBtnMode === '>:up' ? styles.rightUpBtn : styles.rightPressBtn
          }`}
          onClick={this.gotoCheck.bind(this, 'next')}
          onMouseDown={this.switchBtnBg.bind(this, '>:press')}
          onMouseUp={this.switchBtnBg.bind(this, '>:up')}
        />
      </section>
    )
  }

  render() {
    let {
      levelStore: {
        userCheckRecord: { data },
      },
      useShadow,
      acitveGroupId,
    } = this.props
    const { currentCheckGroupIndex, checkHoverId } = this.state
    return (
      <div
        className={styles.checksWrapper}
        style={{
          boxShadow: useShadow
            ? '10px 8px 20px 0px #ffd9d0, 0px 6px 19px 4px rgba(0, 0, 0, 0.4) inset'
            : '',
        }}
      >
        {this.checkGroups.length > 0 ? (
          <div
            className={styles.checks}
            style={{
              width: 1200 * this.checkGroups.length,
              marginLeft: currentCheckGroupIndex * -1200,
              transition: 'all .6s cubic-bezier(0.19, 1, 0.22, 1)',
            }}
          >
            {this.checkGroups.map((checkGroup, index) => {
              const isCurrentCheckGroup = currentCheckGroupIndex === index
              return (
                <div
                  key={index}
                  className={styles.checkGroup}
                  style={{
                    width: 1200,
                    transition: 'all .4s',
                    visibility: isCurrentCheckGroup ? 'visible' : 'hidden',
                    opacity: isCurrentCheckGroup ? 1 : 0,
                  }}
                >
                  {checkGroup.map(check => (
                    <Check
                      key={check.id}
                      data={check}
                      total={data.length}
                      checkHoverId={checkHoverId}
                      acitveGroupId={acitveGroupId}
                      lastCheckOfDoing={this.lastCheckOfDoing}
                      openCheckPanelModal={this.openCheckPanelModal.bind(
                        this,
                        check,
                      )}
                    />
                  ))}
                </div>
              )
            })}
            {dataFormatter(data).length > 10 && this.renderProgress()}
          </div>
        ) : (
          <div className={styles.emptyChecks}>该分组下没有关卡~</div>
        )}
      </div>
    )
  }
}
